module.exports = __webpack_public_path__ + "img/1248.15d78a05.png";